import { initComponent } from './core/init-component';

// Revoq's withdrawal form swaps steps by toggling `hidden` on sibling divs and never moves the page,
// so entering step 2 leaves the viewport where the Continue button was: on mobile the customer lands
// near the bottom of the form, below the line telling them whether their order was found. Their
// bundle has no scroll handling and fires no events, but it does mirror the current step onto
// `data-step` on the form, which is a stable hook. Step 3 and Back already move the page as a side
// effect of focusing an element, so only step 2 needs this.
//
// Revoq have accepted this as a bug on their side. Once their fix ships the guard below turns this
// into a no-op and the file can be deleted.
initComponent('.widerruf-form-block', (block) => {
  const form = block.querySelector('[data-widerruf-form]');

  if (!(form instanceof HTMLElement)) return;

  const scrollToFormTop = () => {
    // The header is not in flow while scrolling: header.ts switches it to `fixed` past 200px and
    // reveals it on scroll-up, which is exactly what this scroll triggers. Leave room for it, or it
    // lands on top of the form heading.
    const header = document.querySelector('.js-header');
    const headerHeight = header instanceof HTMLElement ? header.offsetHeight : 0;
    const rect = block.getBoundingClientRect();

    // Top of the form already on screen and clear of the header: nothing to do.
    if (rect.top >= headerHeight) return;

    const top = Math.max(0, rect.top + window.scrollY - headerHeight);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({ top, behavior: reduceMotion ? 'instant' : 'smooth' });
  };

  const observer = new MutationObserver(() => {
    if (form.dataset.step !== 'details') return;

    // The item list renders in the same tick, so wait for layout before measuring.
    requestAnimationFrame(scrollToFormTop);
  });

  observer.observe(form, { attributes: true, attributeFilter: ['data-step'] });

  return {
    unload: () => observer.disconnect(),
  };
});
